module.exports = __webpack_public_path__ + "img/exit.9e8e3d71.png";